export default __webpack_public_path__ + "static/feedback--mobile@1x-64ada0bfc918fed5b7d28208f56f7fa6.jpg";